"use strict";

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

module.exports = function (promise) {
  if (Array.isArray(promise)) {
    return Promise.all(promise).then(function (data) {
      return {
        data: data,
        error: null
      };
    })["catch"](function (error) {
      return {
        data: null,
        error: error
      };
    });
  } else {
    return promise.then(function (data) {
      return {
        data: data,
        error: null
      };
    })["catch"](function (error) {
      return {
        data: null,
        error: error
      };
    });
  }
};